<template lang="html">
  <div>
    <vs-table :sst="true" :currentPage="currentPage" @change-page="handleChangePage" @sort="handleSort"
      @dblSelection="doubleSelection" @selected="handleSelected" v-model="selected" :total="totalItems" pagination
      :max-items="maximoItems == '' ? 1 : maximoItems" search :data="registros" :max="4" maxHeight="450px">
      <template slot="header">
        <div class="form-group">
          <h5 class="mt-2">{{ titulo }}</h5>
          <input-field class="input-field--stretch col-md-2 ml-5 mr-5" type="tel" v-mask="'###'" v-model="maximoItems"
            id="maximoItems" v-show="mostrarRegistrosPagina" :readonly="!esEditableCantidadRegistro" placeholder>
            <span>Registros</span>
          </input-field>
          <input-field class="input-field--stretch col-md-2 ml-5 mr-5" type="tel" v-model="totalItems" id="totalItems"
            v-show="mostrarRegistrosTotales" :readonly="true" placeholder>
            <span>Registros</span>
          </input-field>
          <div class="select2-field select2-field--stretch" v-show="mostrarSelectedMultiple">
            <v-select id="selectedMultiple" label="descripcion" v-model="form.selectedMultiple"
              :options="columnas.filter(column => column.value != 'id')" @input="inputSelectedMultiple" multiple>
            </v-select>
            <label for="selectedMultiple">Filtros:</label>
          </div>
          <label for="todosSelectedMultiple">
            <input type="checkbox" v-model="form.todosSelectedMultiple" @change="changeTodosSelectedMultiple"
              id="todosSelectedMultiple" name="todosSelectedMultiple" />
            <span>Todos</span>
          </label>
          <label for="camposNull">
            <input type="checkbox" v-model="form.camposNull" @change="changeCamposNull"
              id="camposNull" name="camposNull" />
            <span>Vacíos</span>
          </label>
        </div>
      </template>
      <template slot="thead">
        <vs-th style="min-width: 25%;" :key="indexth" v-for="(columna, indexth) in columnasTh" :sort-key="columna.value" :style="[colorTh ? { backgroundColor: obtenerColor(columna.value, 'boxMac') + '!important' } : {}]">
          <p v-if="mostrarColumna(columna.value)">{{ columna.descripcion }}</p>
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :style="[colorTd ? { backgroundColor: obtenerColor(tr, 'days')} : {}]" :data="tr"
            :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="td == null ? '0.00' : td" v-for="(td, index2) in tr" :key="index2" v-if="mostrarColumna(index2)">
              <p v-if="mostrarColumna(index2) && esCheck(index2)">
                <label>
                  <input type="checkbox" onclick="return false;" :checked="td === 'S' ? true : false" />
                  <span></span>
                </label>
              </p>
              <p v-else-if="mostrarColumna(index2) && index2 === 'number'" class="number">{{
                esEditable(index2) && td == null ?
                  (esTexto(index2) ? '-' : '0.00') : td
              }}</p>
              <p v-else-if="mostrarColumna(index2) && EsResumido(index2)" class="resumido">{{
                esEditable(index2) && td == null ?
                  (esTexto(index2) ? '-' : '0.00') : td
              }}</p>
              <p v-else-if="mostrarColumna(index2)">{{
                esEditable(index2) && td == null ?
                  (esTexto(index2) ? '-' : '0.00') : td
              }}</p>
              <template v-if="esEditable(index2)" slot="edit">
                <vs-input @blur="guardarColumna(td)" class="inputx" v-model="data[indextr][index2]" />
              </template>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>import swal from "sweetalert2";

export default {
  props: {
    columnas: {
      required: true,
    },
    registros: {
      required: true,
    },
    titulo: {
      type: String,
      required: false,
      default: "Resultados",
    },
    columnasInvisibles: {
      required: false,
      default: function () {
        return [];
      },
    },
    registrosPorPagina: {
      required: false,
      default: 10,
    },
    totalItems: {
      required: false,
      type: Number,
      default: 1,
    },
    esEditableCantidadRegistro: {
      required: false,
      type: Boolean,
      default: true,
    },
    currentPage: {
      required: false,
      type: Number,
      default: 1
    },
    mostrarSelectedMultiple: {
      required: false,
      type: Boolean,
      default: false
    },
    columnasEditables: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    columnasTexto: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    columnasCheck: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    mostrarRegistrosPagina: {
      required: false,
      type: Boolean,
      default: false
    },
    mostrarRegistrosTotales: {
      required: false,
      type: Boolean,
      default: false
    },
    colorTd: {
      required: false,
      type: Boolean,
      default: false
    },
    colorTh: {
      required: false,
      type: Boolean,
      default: false
    },
    columnasBox: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    columnasMac: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    columnasNoResumido: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      selected: null,
      maximoItems: this.registrosPorPagina,
      form: {
        selectedMultiple: [],
        todosSelectedMultiple: true,
        camposNull: false
      },
    };
  },
  methods: {
    mostrarColumna: function (clave) {
      return !this.columnasInvisibles.includes(clave);
    },
    esEditable: function (clave, td) {
      return this.columnasEditables.includes(clave);
    },
    esTexto: function (clave, td) {
      return this.columnasTexto.includes(clave);
    },
    esCheck: function (clave) {
      let resultado = false;
      for (let i = 0; i < this.columnasCheck.length; i++) {
        if (clave === this.columnasCheck[i]) {
          resultado = true;
          break;
        }
      }
      return resultado;
    },
    EsResumido: function (clave) {
      return !this.columnasNoResumido.includes(clave);
    },
    doubleSelection: function (tr) {
      this.$emit("seleccionado", tr);
    },
    handleSelected: function (tr) {
      this.$emit("handleSelected", tr);
    },
    handleChangePage(page) {
      this.$emit("handleChangePage", page);
    },
    handleSort(key, active) {
      const sort = [key, active];
      this.$emit("handleSort", sort);
    },
    inputSelectedMultiple: function () {
      this.form.todosSelectedMultiple = false;
      this.$emit("filtrarBusqueda", this.form);
    },
    changeTodosSelectedMultiple: function () {
      if (this.form.todosSelectedMultiple) {
        this.form.selectedMultiple = [];
        this.form.camposNull = false;
      }
      this.$emit("filtrarBusqueda", this.form);
    },
    changeCamposNull: function () {
      if (this.form.camposNull) {
        this.form.todosSelectedMultiple = false;
        if(this.form.selectedMultiple.length === 1)
          this.$emit("filtrarBusqueda", this.form);
        else {
          swal("Debe escoger sólo un filtro", "Advertencia", "warning");
          setTimeout(() => {
            this.form.camposNull = false;
            this.$emit("filtrarBusqueda", this.form);  
          }, 100);
          
        }
      } else {
        this.$emit("filtrarBusqueda", this.form);
      }
    },
    guardarColumna: function (data) {
      if (data != "") {
        axios
          .put(url + "/reporte/actualizarRapido", this.selected)
          .then(function ({ data }) {

          })
          .catch(function () {
            swal("Hubo un error al cargar.", "Error", "error");
          });
      } else
        swal("Ingrese un valor válido", "Error", "error");
    },
    obtenerColor: function (tr, tipo) {
      if(tipo === 'days') {
        if ((tr.aprobado_b === 'S' && !(tr.repaired === 'S')) || (tr.aprobado_m === 'S' && !(tr.repaired_m === 'S'))) {
          if (tr.days > 21)
            return '#FF7E7E';
          if (tr.days >= 14 && tr.days <= 21)
            return ' #EDC19F';
        }
        return 'white';
      }
      if(tipo === 'boxMac'){
        if(this.columnasBox.includes(tr))
          return '#B6E4ED';
        if(this.columnasMac.includes(tr))
          return '#E4C3FA';
        return '#89CFE4'
      }
    },
    limpiar: function () {
      this.form.selectedMultiple = [];
      this.form.todosSelectedMultiple = true;
      this.form.camposNull = false;
    }
  },
  computed: {
    columnasTh: function () {
      let columnasTh = [];
      columnasTh = this.columnas.filter(columna => this.mostrarColumna(columna.value));
      return columnasTh;
    }
  },
  mounted: function () {  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/DynamicTable.vue